import { InterventionReport } from '@inplay/models';

import { ReactNode } from 'react';

export type InterventionReportProps = {};
export type InterventionReportsTableHeaderProps = {
  selectedCount: number;
  searchQuery: string;
  handleOnChangeSearch: (query: string) => void;
  selectedDate: Date | undefined;
  handleSelectedDate?: (date: Date) => void;
  handleReportInterventionClick?: () => void;
  onSettingMenuSelect?: (label: string | undefined) => void;
  disableSettingMenu?: boolean;
  children?: ReactNode;
  reportLabel?: string;
  handleClose?: () => void;
  handleDelete?: () => void;
  handleDownload?: () => void;
  showDownloadLoading?: boolean;
};

export type InterventionReportsTableFilterProps = {
  selectedBranchIDs: string[];
  isOpenUserModal: boolean;
  handleClearFilters: () => void;
  handleApplyFilters: (filters: any) => void;
  toggleFilterModal: (value: boolean) => void;
};

export enum InterventionReportsTableHeader {
  REPORT_NO = 'Report No.',
  NO = 'No.',
  CREATED_ON = 'Created on',
  PLAYER_NO = 'Player No.',
  HARM_OBSERVED = 'Harm Observed',
  FOLLOW_UP_ACTIONS = 'Follow-up Actions',
  TOTAL_INTERVENTIONS = 'Total Interventions',
  CREATED_BY = 'Created By',
  REVIEWED_BY = 'Reviewed By',
  ACTIONS = 'Actions',
  STATUS = 'Intervention Status',
}

export enum InterventionReportsKebabOption {
  VIEW = 'View',
  EDIT = 'Edit',
  REVIEW_AND_SIGN = 'Review & Sign',
  DOWNLOAD = 'Download',
  HISTORY = 'History',
  DELETE = 'Delete',
}

export enum InterventionReportsPendingAction {
  CREATE_INTERVENTION_REPORT = 'CREATE_INTERVENTION_REPORT',
  DELETE_REPORTS = 'DELETE_REPORTS',
  EDIT_REPORT = 'EDIT_REPORT',
  DOWNLOAD_REPORTS = 'DOWNLOAD_REPORTS',
}

export type InterventionReportsFilter = {
  searchQuery: string;
  selectedDate: Date;
  dateCreated?: Date;
  timeCreated?: string;
  playerNo?: string;
};

export type GetInterventionReportsResponse = {
  statusCode: number;
  status: string;
  message: string;
  data: {
    reports: InterventionReport[];
  };
};

export type InterventionReportDetailsProps = {
  interventionReport: InterventionReport;
  onClose: () => void;
  onReviewAndSign?: () => void;
  onKebabAction?: (action: string) => void;
};
